import { render, staticRenderFns } from "./TheUserIcon.vue?vue&type=template&id=50b74ad0&"
import script from "./TheUserIcon.vue?vue&type=script&lang=js&"
export * from "./TheUserIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports